import { IS_SSR } from '@libs/common-next';
import { PDP_FINDING_METHOD_BY_SKU } from '@libs/core';

/**
 * Store the finding method for a specific SKU in localStorage
 * @param sku - The product SKU
 * @param method - The finding method value from window.sessionStorage.pdpFindingMethod
 */
export const setSkuFindingMethod = (sku: string, method: string | undefined): void => {
    if (!sku || IS_SSR) return;

    try {
        const existing = window.localStorage.getItem(PDP_FINDING_METHOD_BY_SKU);
        const map = existing ? JSON.parse(existing) : {};

        // Store the method (or empty string if undefined)
        map[sku] = method ?? '';

        window.localStorage.setItem(PDP_FINDING_METHOD_BY_SKU, JSON.stringify(map));
    } catch (error) {
        console.error('Error storing SKU finding method:', error);
    }
};

/**
 * Retrieve the finding method for a specific SKU from localStorage
 * @param sku - The product SKU
 * @returns The finding method string, or empty string if not found
 */
export const getSkuFindingMethod = (sku: string | undefined): string => {
    if (!sku || IS_SSR) {
        return '';
    }

    try {
        const existing = window.localStorage.getItem(PDP_FINDING_METHOD_BY_SKU);
        if (!existing) {
            return '';
        }

        const map = JSON.parse(existing);
        return map[sku] ?? '';
    } catch (error) {
        return '';
    }
};

/**
 * Clear all SKU finding method mappings from localStorage
 * Should be called after purchase completion
 */
export const clearSkuFindingMethods = (): void => {
    if (IS_SSR) return;

    window.localStorage.removeItem(PDP_FINDING_METHOD_BY_SKU);
};
